<template>
    <div>
        <div class="form-info-banner">
            <h3 class="form-info-banner-title">Os campos com * são de preenchimento obrigatório</h3>
            <p class="form-info-banner-text">Caso queira, você poderá salvar e continuar depois.</p>
        </div>
        <div class="space-y-8">
            <section class="form-section">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados pessoais'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'"
                        :SubSessao="'Dados pessoais'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="nome">Nome</label>
                            <input class="field" type="text" id="nome" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.Nome" disabled="true" placeholder="José da Silva">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="cpf">CPF</label>
                            <input class="field" type="text" id="cpf" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.Cpf" disabled="true" placeholder="123.456.789-10">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="situacaoLegal">Situação legal</label>
                            <select id="situacaoLegal" @change="salvarAlteracoesLocalmente" v-model="localPF.SituacaoLegal" class="field">
                                <option value="1">Maior</option>
                                <option value="2">Menor</option>
                                <option value="3">Emancipado</option>
                                <option value="4">Espólio</option>
                                <option value="5">Interditado/Incapaz</option>
                                <option value="6">Falecido</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-grid-4">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="dataNascimento">Data de nascimento</label>
                            <input class="field" type="date" id="dataNascimento" @change="checkMenorIdade"
                                v-model="localPF.DataNascimento" placeholder="00/00/0000">
                            <p v-if="camposObrigatorios.erroDataNascimento" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="sexo">Sexo</label>
                            <select id="sexo" @change="salvarAlteracoesLocalmente" v-model="localPF.Sexo" class="field">
                                <option value="">Selecione</option>
                                <option value="Feminino">Feminino</option>
                                <option value="Masculino">Masculino</option>
                            </select>
                            <p v-if="camposObrigatorios.erroSexo" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <telefone-internacional 
                                v-if="inicializado"
                                v-model="localPF.Telefone" 
                                label="Telefone Celular*" 
                                name="Telefone"
                                :permitirApenascelular='true'
                                @change="salvarAlteracoesLocalmente"
                                @validate="onValidateTelefone"
                            />
                            <p v-if="camposObrigatorios.erroTelefoneCelular" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <telefone-internacional 
                                v-if="inicializado"
                                v-model="localPF.Telefone2" 
                                label="Telefone Residencial" 
                                name="Telefone2"
                                :opcional="true"
                                @change="salvarAlteracoesLocalmente"
                                @validate="onValidateTelefone"
                            />
                        </div>
                    </div>
                    <div class="form-grid-2">
                        <div class="form-field">
                            <InputNome 
                                v-model="localPF.NomePai"
                                label="Nome do pai"
                                :required="true"
                                :erro="camposObrigatorios.erroNomePai"
                                @blur="salvarAlteracoesLocalmente"
                            />
                        </div>
                        <div class="form-field">
                            <InputNome 
                                v-model="localPF.NomeMae"
                                label="Nome da mãe"
                                :required="true"
                                :erro="camposObrigatorios.erroNomeMae"
                                @blur="salvarAlteracoesLocalmente"
                            />
                        </div>
                    </div>
                    <div class="form-grid-4">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="tipoDocumento">Tipo do documento</label>
                            <select id="tipoDocumento" class="field" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.TipoDocumento">
                                <option value="">Selecione</option>
                                <option value="RG">RG</option>
                                <option value="CNH">CNH</option>
                                <option value="Passaporte">Passaporte</option>
                                <option value="Céd. Ident. - Estrangeiro (RNE)">Céd. Ident. - Estrangeiro (RNE)</option>
                                <option value="Céd. Ident. - Militar (CIM)">Céd. Ident. - Militar (CIM)</option>
                                <option value="Céd. Ident. - Profissional (CIP)">Céd. Ident. - Profissional (CIP)</option>
                                <option value="Céd. Ident. Prof. - Func Órgão Público (CIPF)">Céd. Ident. Prof. - Func Órgão Público (CIPF)</option>
                                <option value="Certidão de Nascimento (CN)">Certidão de Nascimento (CN)</option>
                                <option value="Identificação Prisional (IP)">Identificação Prisional (IP)</option>
                                <option value="Inscrição Estadual (IE)">Inscrição Estadual (IE)</option>
                                <option value="Laissez Passer (LPASS)">Laissez Passer (LPASS)</option>
                                <option value="Número Ident. Registro Empresa (NIRE)">Número Ident. Registro Empresa (NIRE)</option>
                            </select>
                            <p v-if="camposObrigatorios.erroTipoDocumento" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="NumeroDocumento">Nº do documento identificação</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-model="localPF.NumeroDocumento"
                                type="text" id="NumeroDocumento">
                            <p v-if="camposObrigatorios.erroNumeroDocumento" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="DataEmissao">Data de emissão</label>
                            <input class="field" @change="salvarAlteracoesLocalmente" v-model="localPF.DataEmissao"
                                type="date" placeholder="00/00/0000">
                            <p v-if="camposObrigatorios.erroDataEmissao" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="DocumentoUf">Estado emissor</label>
                            <select id="DocumentoUf" @change="salvarAlteracoesLocalmente" v-model="localPF.DocumentoUf"
                                class="field">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroDocumentoUf" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="orgaoEmissor">Órgão emissor</label>
                            <select id="orgaoEmissor" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.OrgaoEmissao" class="field">
                                <option value="">Selecione</option>
                                <option v-for="orgao in listaOrgaoEmissor" :key="orgao.Value"
                                    :value="orgao.Value">
                                    {{ orgao.Text }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroOrgaoEmissao" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="nacionalidade">Nacionalidade</label>
                            <select id="nacionalidade" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.Nacionalidade" class="field">
                                <option value="">Selecione</option>
                                <option value="1">Brasileiro Nato</option>
                                <option value="2">Brasileiro Naturalizado</option>
                                <option value="3">Estrangeiro</option>
                            </select>
                            <p v-if="camposObrigatorios.erroNacionalidade" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field" v-if="localPF.Nacionalidade == 1">
                            <label class="form-field-label form-field-label-required" for="Naturalidade">Estado de nascimento</label>
                            <select id="Naturalidade" @change="salvarAlteracoesLocalmente" v-model="localPF.Naturalidade"
                                class="field">
                                <option value="null">Selecione</option>
                                <option v-for="uf in ufs" :key="uf" :value="uf">
                                    {{ uf }}
                                </option>
                            </select>
                        </div>
                        <div class="form-field" v-if="localPF.Nacionalidade != 1">
                            <label class="form-field-label form-field-label-required" for="paisNascimento">País de nascimento</label>
                            <select id="paisNascimento" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.PaisNascimento" class="field">
                                <option value="">Selecione</option>
                                <option v-for="nacionalidade in listaNacionalidades" :key="nacionalidade.Value"
                                    :value="nacionalidade.Value">
                                    {{ nacionalidade.Text }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroPaisNascimento" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="cidadeNascimento">Cidade de nascimento</label>
                            <select id="cidadeNascimento" v-if="localPF.Nacionalidade == 1" @change="salvarAlteracoesLocalmente" v-model="localPF.CidadeNascimento"
                                class="field">
                                <option value="null">Selecione</option>
                                <option v-for="cidade in listaCidades" :key="cidade.descricao" :value="cidade.descricao">
                                    {{ cidade.descricao }}
                                </option>
                            </select>
                            <input class="field" 
                                @change="salvarAlteracoesLocalmente" 
                                v-if="localPF.Nacionalidade != 1" 
                                v-model="localPF.CidadeNascimento" 
                                type="text" id="CidadeNascimentoText">
                            <p v-if="camposObrigatorios.erroCidadeNascimento" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="estadoCivil">Estado civil</label>
                            <select id="estadoCivil" @change="salvarAlteracoesLocalmente" class="field"
                                v-model="localPF.EstadoCivil">
                                <option value="">Selecione</option>
                                <option v-for="estadoCivil in estadosCivis" :key="estadoCivil" :value="estadoCivil">
                                    {{ estadoCivil }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroEstadoCivil" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            
            <section class="form-section"
                v-if="localPF.EstadoCivil.toLocaleLowerCase().includes('casado') || localPF.EstadoCivil == 'Em união estável'">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados do Cônjuge'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'"
                        :SubSessao="'Dados cônjugue'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-2">
                        <div class="form-field">
                            <InputNome 
                                v-model="localPF.NomeConjugue"
                                label="Nome"
                                :required="true"
                                :erro="camposObrigatorios.erroNomeConjugue"
                                @blur="salvarAlteracoesLocalmente"
                            />
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="cpfConjugue">CPF</label>
                            <input class="field" v-mask="'###.###.###-##'" type="text" id="cpfConjugue"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.CpfConjugue">
                            <p v-if="camposObrigatorios.erroCpfConjugue" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section class="form-section"
                v-if="localPF.SituacaoLegal == 5 || localPF.SituacaoLegal == 2 || localPF.SituacaoLegal == 4">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Identificação de represente/tutor'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'"
                        :SubSessao="'Dados Representante_Tutor'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="nomeRepresentante">Nome</label>
                            <input class="field" type="text" id="nomeRepresentante" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.NomeRepresentante">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="grauRelacionamento">Grau de relacionamento</label>
                            <select id="grauRelacionamento" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.GrauRelacionamento" class="field">
                                <option value="1">Pai/Mãe</option>
                                <option value="2">Curador</option>
                                <option value="3">Inventariante</option>
                                <option value="5">Tutor</option>
                            </select>
                        </div>
                    </div>
                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">Será emissor de ordem?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input type="radio" id="emissorOrdemNao" value="false" name="emissorOrdem" class="form-radio-input"
                                        v-model="localPF.EmissorOrdem" @change="salvarAlteracoesLocalmente" />
                                    <label for="emissorOrdemNao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input type="radio" id="emissorOrdemSim" value="true" name="emissorOrdem" class="form-radio-input"
                                        v-model="localPF.EmissorOrdem" @change="salvarAlteracoesLocalmente" />
                                    <label for="emissorOrdemSim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required">É uma pessoa Exposta Politicamente?</label>
                            <div class="form-radio-group">
                                <div class="form-radio-item">
                                    <input type="radio" id="pepRepresentanteNao" value="false" name="pepRepresentante"
                                        class="form-radio-input" v-model="localPF.PepRepresentante"
                                        @change="salvarAlteracoesLocalmente" />
                                    <label for="pepRepresentanteNao" class="form-radio-label">Não</label>
                                </div>
                                <div class="form-radio-item">
                                    <input type="radio" id="pepRepresentanteSim" value="true" name="pepRepresentante"
                                        class="form-radio-input" v-model="localPF.PepRepresentante"
                                        @change="salvarAlteracoesLocalmente" />
                                    <label for="pepRepresentanteSim" class="form-radio-label">Sim</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="NumeroDocumentoRep">Nº do documento identificação</label>
                            <input class="field" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.DocumentoRepresentante" type="text" id="NumeroDocumentoRep">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="CpfRepresentante">CPF</label>
                            <input class="field" v-mask="'###.###.###-##'" type="text" id="CpfRepresentante"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.CpfRepresentante">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="EmailRepresentante">E-mail</label>
                            <input class="field" type="text" id="EmailRepresentante"
                                @change="salvarAlteracoesLocalmente" @blur="validarEmailRepresentante" v-model="localPF.EmailRepresentante">
                            <p v-if="emailErros.EmailRepresentante" class="form-field-error">{{ emailErros.EmailRepresentante }}</p>
                        </div>
                    </div>
                    
                    <div class="flex justify-start mb-6">
                        <button class="btn-secondary" @click="habilitarSegundoRepresentante()">
                            + Adicionar outro representante/tutor
                        </button>
                    </div>
                    
                    <div v-if="segundoRepresentante" class="space-y-4">
                        <div class="form-grid-5">
                            <div class="form-field">
                                <label class="form-field-label form-field-label-required" for="nomeRepresentante2">Nome</label>
                                <input class="field" type="text" id="nomeRepresentante2"
                                    @change="salvarAlteracoesLocalmente" v-model="localPF.NomeRepresentante2">
                            </div>
                            <div class="form-field">
                                <label class="form-field-label form-field-label-required" for="grauRelacionamento2">Grau de relacionamento</label>
                                <select id="grauRelacionamento2" @change="salvarAlteracoesLocalmente"
                                    v-model="localPF.GrauRelacionamento2" class="field">
                                    <option value="1">Pai/Mãe</option>
                                    <option value="2">Curador</option>
                                    <option value="3">Inventariante</option>
                                    <option value="4">Procurador</option>
                                    <option value="5">Tutor</option>
                                </select>
                            </div>
                            <div class="form-field">
                                <label class="form-field-label form-field-label-required">Será emissor de ordem?</label>
                                <div class="form-radio-group">
                                    <div class="form-radio-item">
                                        <input type="radio" id="emissorOrdem2Nao" value="false" name="emissorOrdem_2" class="form-radio-input"
                                            v-model="localPF.EmissorOrdem2" @change="salvarAlteracoesLocalmente" />
                                        <label for="emissorOrdem2Nao" class="form-radio-label">Não</label>
                                    </div>
                                    <div class="form-radio-item">
                                        <input type="radio" id="emissorOrdem2Sim" value="true" name="emissorOrdem_2" class="form-radio-input"
                                            v-model="localPF.EmissorOrdem2" @change="salvarAlteracoesLocalmente" />
                                        <label for="emissorOrdem2Sim" class="form-radio-label">Sim</label>
                                    </div>
                                </div>
                            </div>
                            <div class="form-field">
                                <label class="form-field-label form-field-label-required">É uma pessoa Exposta Politicamente?</label>
                                <div class="form-radio-group">
                                    <div class="form-radio-item">
                                        <input type="radio" id="pepRepresentante2Nao" value="false" name="pepRepresentante_2"
                                            class="form-radio-input" v-model="localPF.PepRepresentante2"
                                            @change="salvarAlteracoesLocalmente" />
                                        <label for="pepRepresentante2Nao" class="form-radio-label">Não</label>
                                    </div>
                                    <div class="form-radio-item">
                                        <input type="radio" id="pepRepresentante2Sim" value="true" name="pepRepresentante_2"
                                            class="form-radio-input" v-model="localPF.PepRepresentante2"
                                            @change="salvarAlteracoesLocalmente" />
                                        <label for="pepRepresentante2Sim" class="form-radio-label">Sim</label>
                                    </div>
                                </div>
                            </div>
                            <div class="flex items-end">
                                <button @click.prevent="desabilitarSegundoRepresentante()" 
                                    class="btn-icon-danger" 
                                    title="Excluir representante/tutor">
                                    <Icon icon="ico-delete" />
                                </button>
                            </div>
                        </div>
                        <div class="form-grid-3">
                            <div class="form-field">
                                <label class="form-field-label form-field-label-required" for="NumeroDocumentoRep2">Nº do documento identificação</label>
                                <input class="field" @change="salvarAlteracoesLocalmente"
                                    v-model="localPF.DocumentoRepresentante2" type="text" id="NumeroDocumentoRep2">
                            </div>
                            <div class="form-field">
                                <label class="form-field-label form-field-label-required" for="cpfRepresentante2">CPF</label>
                                <input class="field" type="text" id="cpfRepresentante2" v-mask="'###.###.###-##'"
                                    @change="salvarAlteracoesLocalmente" v-model="localPF.CpfRepresentante2">
                            </div>
                            <div class="form-field">
                                <label class="form-field-label form-field-label-required" for="EmailRepresentante2">E-mail</label>
                                <input class="field" type="text" id="EmailRepresentante2"
                                    @change="salvarAlteracoesLocalmente" @blur="validarEmailRepresentante2" v-model="localPF.EmailRepresentante2">
                                <p v-if="emailErros.EmailRepresentante2" class="form-field-error">{{ emailErros.EmailRepresentante2 }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section class="form-section">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados profissionais'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'"
                        :SubSessao="'Dados profissionais'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-3">
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="formacaoProfissional">Formação Acadêmica</label>
                            <select id="formacaoProfissional" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.FormacaoProfissional" class="field">
                                <option value="null">Selecione</option>
                                <option v-for="item in listaFormacacaoProfissional" :key="item.Descricao"
                                    :value="item.Descricao">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroFormacaoProfissional" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field">
                            <label class="form-field-label form-field-label-required" for="ocupacaoProfissional">Ocupação profissional</label>
                            <select id="ocupacaoProfissional" @change="ocupacaoProfissionalAlteracao" class="field"
                                v-model="localPF.Ocupacao">
                                <option value="null">Selecione</option>
                                <option v-for="item in listaOcupacaoProfissional" :key="item.Codigo"
                                    :value="item.Codigo">
                                    {{ item.Descricao }}
                                </option>
                            </select>
                            <p v-if="camposObrigatorios.erroOcupacao" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                        <div class="form-field" v-if="localPF.Ocupacao == 'outros'">
                            <label class="form-field-label form-field-label-required" for="especifiqueOcupacao">Especifique a ocupação</label>
                            <input class="field" type="text" id="especifiqueOcupacao"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.OcupacaoOutro">
                            <p v-if="camposObrigatorios.erroOcupacaoOutro" class="form-field-error">
                                Campo obrigatório.
                            </p>
                        </div>
                    </div>
                </div>
            </section>
            <section class="form-section">
                <div class="form-section-header">
                    <LabelDisclaimer :TamanhoFonteLabel="'H5'" :NomeLabel="'Dados da empresa'"
                        :TipoCliente="'Pessoa Física'" :Sessao="'Informação do Cliente'" :SubSessao="'Dados empresa'" />
                </div>
                <div class="form-section-content">
                    <div class="form-grid-2">
                        <div class="form-field">
                            <label class="form-field-label" for="nomeEmpresa">Nome da empresa</label>
                            <input class="field" type="text" id="nomeEmpresa" v-model="localPF.Instituicao"
                                @change="salvarAlteracoesLocalmente">
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="cnpjEmpresa">CNPJ da empresa</label>
                            <input class="field" type="text" id="cnpjEmpresa" v-mask="'##.###.###/####-##'"
                                @change="salvarAlteracoesLocalmente" v-model="localPF.CnpjTrabalha">
                        </div>
                    </div>
                    <div class="form-grid-2">
                        <div class="form-field">
                            <telefone-internacional 
                                v-if="inicializado"
                                v-model="localPF.TelefoneComercial" 
                                label="Telefone Comercial" 
                                name="TelefoneComercial"
                                :opcional="true"
                                @change="salvarAlteracoesLocalmente"
                                @validate="onValidateTelefone"
                            />
                        </div>
                        <div class="form-field">
                            <label class="form-field-label" for="EmailComercial">E-mail Comercial</label>
                            <input class="field" type="text" id="EmailComercial" @change="salvarAlteracoesLocalmente"
                                v-model="localPF.EmailComercial" @blur="validarEmail">
                            <p v-if="emailErros.EmailComercial" class="form-field-error">{{ emailErros.EmailComercial }}</p>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
    <ModalInformativoPep />
    <ModalAlerta v-if="modalAlerta.mostrar" :mostrar="modalAlerta.mostrar" :tipo="modalAlerta.tipo" :titulo="modalAlerta.titulo" :mensagem="modalAlerta.mensagem" @fechar="modalAlerta.mostrar = false" />
</template>

<script>

import { mapGetters } from 'vuex';
import ModalInformativoPep from '../PEP/ModalInformativoPep.vue';
import LabelDisclaimer from '@/components/LabelDisclaimer.vue';
import { ufs } from '@/utils/formUtils';
import emailValidatorMixin from '@/utils/emailValidatorMixin.js';
import ModalAlerta from '../Utilitarios/ModalAlerta.vue';

export default {
    name: 'CadastroPF_Informacoes',
    props: ['Edicao'],
    mixins: [emailValidatorMixin],
    components: { ModalInformativoPep, LabelDisclaimer, ModalAlerta },
    computed: {
        ...mapGetters({
            user: 'auth/user',
            etapaCadastro: 'GET_ETAPA_CADASTRO',
            infoBasicas: 'GET_PF_INFO_BASICAS',
            listaFormacacaoProfissional: 'GET_LISTA_FORMACAO_PROFISSIONAL',
            listaOcupacaoProfissional: 'GET_LISTA_OCUPACAO_PROFISSIONAL',
            listaNacionalidades: 'GET_LISTA_NACIONALIDADES',
            listaCidades: 'GET_LISTA_CIDADE',
            listaOrgaoEmissor: 'GET_LISTA_ORGAO_EMISSOR',
            localPFObjSalvo: 'GET_PF_SALVAR_INFO_BASICAS',
            infoComplementoRepresentantes: 'GET_PF_INFO_BASICAS_REPRESENTANTES',
        }),
        ufs() {
            return ufs;
        },
    },
    data() {
        return {
            modalAlerta: {
                mostrar: false,
                tipo: 'warning',
                titulo: '',
                mensagem: ''
            },
            emailErros: {},
            inicializado: false,
            segundoRepresentante: false,
            permitirAvancar: false,
            telefoneValido: [],
            representantes: [{
                Guid: '',
                Nome: '',
                Documento: '',
                Cpf: '',
                EmissorOrdem: false,
                UsPerson: false,
                PoliticamenteExposta: false,
                Tipo: 'tutor'
            }],
            camposObrigatorios: {
                erroDataNascimento: false,
                erroSexo: false,
                erroTelefoneCelular: false,
                erroNomePai: false,
                erroNomeMae: false,
                erroNacionalidade: false,
                erroPaisNascimento: false,
                erroNaturalidade: false,
                erroCidadeNascimento: false,
                erroTipoDocumento: false,
                erroNumeroDocumento: false,
                erroDataEmissao: false,
                erroOrgaoEmissao: false,
                erroDocumentoUf: false,
                erroEstadoCivil: false,
                erroFormacaoProfissional: false,
                erroOcupacaoOutro: false,
                erroCpfConjugue: false,
                erroNomeConjugue: false
            },
            novoRepresentante: {
                Guid: '',
                Nome: '',
                Documento: '',
                Cpf: '',
                EmissorOrdem: false,
                UsPerson: false,
                PoliticamenteExposta: false,
                Tipo: 'tutor'
            },
            menorIdade: false,
            localPF: {
                DataNascimento: null,
                Sexo: '',
                EstadoCivil: '',
                OcupacaoProfissional: '',
                NumeroDocumento: '',
                TipoDocumento: '',
                DataEmissao: null,
                OrgaoEmissao: '',
                DocumentoUf: '',
                Nacionalidade: '',
                PaisNascimento: '',
                Naturalidade: '',
                CidadeNascimento: '',
                Pais: '',
                NomeMae: '',
                NomePai: '',
                NomeConjugue: '',
                CpfConjugue: '',
                Logradouro: '',
                LogradouroNumero: '',
                LogradouroComplemento: '',
                Bairro: '',
                Cidade: '',
                Cep: '',
                Uf: '',
                LogradouroPais: '',
                Telefone: '',
                Telefone2: '',
                Email: '',
                PoliticamenteExposta: false,
                PoliticamenteExpostaDescricao: '',
                FormacaoProfissional: '',
                Instituicao: '',
                Ocupacao: '',
                CnpjTrabalha: '',
                EnderecoComercial: '',
                EnderecoComercialNumero: '',
                EnderecoComercialComplemento: '',
                EnderecoComercialBairro: '',
                EnderecoComercialCep: '',
                EnderecoComercialCidade: '',
                EnderecoComercialEstado: '',
                EnderecoComercialPais: '',
                TelefoneComercial: '',
                EmailComercial: '',
                EnderecoCorrespondencia: '',
                LogradouroOutro: '',
                LogradouroNumeroOutro: '',
                LogradouroComplementoOutro: '',
                BairroOutro: '',
                CidadeOutro: '',
                UfOutro: '',
                CepOutro: '',
                PaisOutro: '',
                ClienteIncapaz: false,
                ClienteEmancipado: false,
                NomeRepresentante: '',
                GrauRelacionamento: '',
                EmissorOrdem: false,
                DocumentoRepresentante: '',
                CpfRepresentante: '',
                PepRepresentante: false,
                NomeRepresentante2: '',
                GrauRelacionamento2: '',
                EmissorOrdem2: false,
                DocumentoRepresentante2: '',
                CpfRepresentante2: '',
                PepRepresentante2: false,
                SituacaoLegal: 1,
            },
            estadosCivis: [
                'Solteiro(a)', 'Casado(a) com Brasileiro(a) Nato(a)', 'Casado(a) com Brasileiro(a) Naturalizado(a)', 'Casado(a) com Estrangeiro(a)', 'Divorciado(a)',
                'Viúvo(a)', 'Separado(a) judicialmente', 'Em união estável'
            ],
        };
    },
    mounted() {
        if (this.localPFObjSalvo != null) {
            this.localPF = this.localPFObjSalvo;
        } else {
            this.localPF = this.formatarDados(this.infoBasicas);
            this.checkMenorIdade();
        }
        if (this.infoComplementoRepresentantes != null && this.infoComplementoRepresentantes.length > 0) {
            this.representantes = this.infoComplementoRepresentantes;
        }
        this.localPF.Nome = this.infoBasicas.Nome;
        this.localPF.Cpf = this.infoBasicas.Cpf;
        if (this.localPF.NomeRepresentante2 != '' && this.localPF.NomeRepresentante2 != null) {
            this.segundoRepresentante = true;
        }
        this.$store.commit('SET_MODAL_PEP_INFORMATIVO', false);
        this.validarFormulario();
        this.inicializado = true;
    },
    methods: {
        onValidateTelefone({ name, valid }) {
            if (!this.telefoneValido) {
                this.telefoneValido = {};
            }
            if(valid != 'undefined'){
                if(!(name == 'Telefone2' && this.localPF.Telefone2.length < 4) && 
                    !(name == 'TelefoneComercial' && this.localPF.TelefoneComercial.length < 4)){
                    this.telefoneValido[name] = valid;
                }
            }
        },
        habilitarSegundoRepresentante() {
            this.segundoRepresentante = true;
        },
        validarEmail() {
            this.validarEmailGeneric(this.localPF.EmailComercial, 'EmailComercial', {
                obrigatorio: false,
            });
        },
        validarEmailRepresentante() {
            this.validarEmailGeneric(this.localPF.EmailRepresentante, 'EmailRepresentante', {
                obrigatorio: [2, 4, 5].includes(parseInt(this.localPF.SituacaoLegal)),
            });
        },
        validarEmailRepresentante2() {
            this.validarEmailGeneric(this.localPF.EmailRepresentante2, 'EmailRepresentante2', {
                obrigatorio: [2, 4, 5].includes(parseInt(this.localPF.SituacaoLegal)) && !!(this.localPF.NomeRepresentante2 || this.localPF.GrauRelacionamento2 ||
                    this.localPF.DocumentoRepresentante2 || this.localPF.EmailRepresentante2 ||
                    this.localPF.CpfRepresentante2),
            });
        },
        desabilitarSegundoRepresentante() {
            this.segundoRepresentante = false;
            this.localPF.NomeRepresentante2 = '';
            this.localPF.GrauRelacionamento2 = '';
            this.localPF.EmissorOrdem2 = false;
            this.localPF.DocumentoRepresentante2 = '';
            this.localPF.EmailRepresentante2 = '';
            this.localPF.CpfRepresentante2 = '';
            this.localPF.PepRepresentante2 = false;
            this.salvarAlteracoesLocalmente();
        },
        checkMenorIdade() {
            var hoje = new Date();
            var dataNascimento = new Date(this.localPF.DataNascimento);
            var idade = hoje.getFullYear() - dataNascimento.getFullYear();
            var m = hoje.getMonth() - dataNascimento.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < dataNascimento.getDate())) {
                idade--;
            }
            this.menorIdade = idade < 18;
            this.salvarAlteracoesLocalmente();
        },
        proximaEtapa() {
            if (this.validarFormulario(true)) {
                this.$store.commit('SET_ETAPA_CADASTRO', 1);
                this.$store.commit('SET_SALVAR_INFO_DES_NOTIFICACAO', true);
                this.salvarInformacoes();
            }
        },
        validarFormulario(submeter) {
            this.permitirAvancar = true;
            this.camposObrigatorios = {
                erroDataNascimento: false,
                erroSexo: false,
                erroTelefoneCelular: false,
                erroNomePai: false,
                erroNomeMae: false,
                erroPaisNascimento: false,
                erroNacionalidade: false,
                erroNaturalidade: false,
                erroCidadeNascimento: false,
                erroTipoDocumento: false,
                erroNumeroDocumento: false,
                erroDataEmissao: false,
                erroOrgaoEmissao: false,
                erroDocumentoUf: false,
                erroEstadoCivil: false,
                erroFormacaoProfissional: false,
                erroOcupacaoOutro: false,
                erroCpfConjugue: false,
                erroNomeConjugue: false
            };
            var nomeDoCampo = '';
            var nomeDoCampoOpcionalInvalido = '';
            if (!this.localPF.DataNascimento || this.localPF.DataNascimento == null) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroDataNascimento = true;
                    nomeDoCampo = 'Data de nascimento';
                }
                this.permitirAvancar = false;
            }
            if (!['Masculino', 'Feminino'].includes(this.localPF.Sexo)) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroSexo = true;
                    nomeDoCampo = 'Sexo';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Telefone) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroTelefoneCelular = true;
                    nomeDoCampo = 'Telefone Celular';
                }
                this.permitirAvancar = false;
            }


            if (!this.localPF.Telefone|| this.telefoneValido.Telefone == false) {
            if (submeter && this.permitirAvancar) {
                this.camposObrigatorios.erroTelefone = true;
                nomeDoCampo = 'Celular';
            }
                if(this.telefoneValido.Telefone == false){
                    nomeDoCampoOpcionalInvalido = 'Celular';
                }
                this.permitirAvancar = false;
            }

            if (
            this.localPF.Telefone2.length > 4 &&
            (!this.localPF.Telefone2 || this.telefoneValido.Telefone2 == false)
            ) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTelefone2 = true;
                    nomeDoCampoOpcionalInvalido = 'Telefone Residencial';
                }
                this.permitirAvancar = false;
            }


            if (
            this.localPF.TelefoneComercial.length > 4 &&
            (!this.localPF.TelefoneComercial || this.telefoneValido.TelefoneComercial == false)
            ) {
                if (submeter && this.permitirAvancar) {
                    this.camposObrigatorios.erroTelefone2 = true;
                    nomeDoCampoOpcionalInvalido = 'Telefone Comercial';
                }
                this.permitirAvancar = false;
            }


            if (!this.localPF.NomePai) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroNomePai = true;
                    nomeDoCampo = 'Nome do Pai';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.NomeMae) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroNomeMae = true;
                    nomeDoCampo = 'Nome da mãe';
                }
                this.permitirAvancar = false;
            }
            if (Object.values(this.emailErros).some(erro => erro !== '')) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    nomeDoCampoOpcionalInvalido = 'E-mail Comercial';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.TipoDocumento) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroTipoDocumento = true;
                    nomeDoCampo = 'Tipo do Documento';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.NumeroDocumento) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroNumeroDocumento = true;
                    nomeDoCampo = 'Nº do Documento identificação';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.DataEmissao) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroDataEmissao = true;
                    nomeDoCampo = 'Data de emissão';
                }
                this.permitirAvancar = false;
            }

            if (!this.ufs.includes(this.localPF.DocumentoUf)) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroDocumentoUf = true;
                    nomeDoCampo = 'UF';
                }
                this.permitirAvancar = false;
            }

            if (!this.localPF.OrgaoEmissao) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroOrgaoEmissao = true;
                    nomeDoCampo = 'Orgão emissor';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Nacionalidade || (this.localPF.Nacionalidade != 1 && this.localPF.Nacionalidade != 2 && this.localPF.Nacionalidade != 3)) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroNacionalidade = true;
                    nomeDoCampo = 'Nacionalidade';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Naturalidade && this.localPF.Nacionalidade == 1) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroNaturalidade = true;
                    nomeDoCampo = 'Estado de nascimento';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.PaisNascimento && this.localPF.Nacionalidade != 1) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroPaisNascimento = true;
                    nomeDoCampo = 'País de nascimento';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.CidadeNascimento || this.localPF.CidadeNascimento == '' || this.localPF.CidadeNascimento == 'null') {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroCidadeNascimento = true;
                    nomeDoCampo = 'Cidade de nascimento';
                }
                this.permitirAvancar = false;
            }

            if (!this.estadosCivis.includes(this.localPF.EstadoCivil)) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroEstadoCivil = true;
                    nomeDoCampo = 'Estado Civil';
                }
                this.permitirAvancar = false;
            }
            if (this.localPF.EstadoCivil.toLocaleLowerCase().includes('casado') || this.localPF.EstadoCivil == 'Em união estável') {
                if (!this.localPF.NomeConjugue) {
                    if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                        this.camposObrigatorios.erroNomeConjugue = true;
                        nomeDoCampo = 'Nome do Cônjugue';
                    }
                    this.permitirAvancar = false;
                }
                if (!this.localPF.CpfConjugue) {
                    if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                        this.camposObrigatorios.erroCpfConjugue = true;
                        nomeDoCampo = 'CPF do Cônjugue';
                    }
                    this.permitirAvancar = false;
                }
            }
            if (!this.localPF.FormacaoProfissional) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroFormacaoProfissional = true;
                    nomeDoCampo = 'Formação Acadêmica';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.Ocupacao) {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroOcupacao = true;
                    nomeDoCampo = 'Ocupação Profissional';
                }
                this.permitirAvancar = false;
            }
            if (!this.localPF.OcupacaoOutro && this.localPF.Ocupacao == 'outros') {
                if (submeter && nomeDoCampo == '' && this.permitirAvancar) {
                    this.camposObrigatorios.erroOcupacaoOutro = true;
                    nomeDoCampo = 'Especifique a ocupação';
                }
                this.permitirAvancar = false;
            }

            // validação quando SituacaoLegal é 2, 4 ou 5
            const exigeRepresentante = [2, 4, 5].includes(parseInt(this.localPF.SituacaoLegal));

            if (exigeRepresentante && submeter && this.permitirAvancar) {

                const repAlgumPreenchido =
                    !(this.localPF.NomeRepresentante || this.localPF.GrauRelacionamento ||
                    this.localPF.DocumentoRepresentante || this.localPF.EmailRepresentante ||
                    this.localPF.CpfRepresentante);

                    if(repAlgumPreenchido){
                        this.modalAlerta = {
                            mostrar: true,
                            tipo: 'warning',
                            titulo: 'Atenção: Campo obrigatório',
                            mensagem: 'É necessário informar o responsável legal para prosseguir com o cadastro.'
                        };
                        this.permitirAvancar = false;
                        return this.permitirAvancar;
                    }

                console.log('this.localPF.NomeRepresentante', this.localPF.NomeRepresentante);
                // REPRESENTANTE PRINCIPAL
                if (!this.localPF.NomeRepresentante || this.localPF.NomeRepresentante.trim() === '') {
                    if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                        this.camposObrigatorios.erroNomeRepresentante = true;
                        nomeDoCampo = 'Nome do Representante';
                    }
                    console.log('entrou aqui');
                    this.permitirAvancar = false;
                }

                if (!this.localPF.GrauRelacionamento || this.localPF.GrauRelacionamento == '') {
                    if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                        this.camposObrigatorios.erroGrauRelacionamento = true;
                        nomeDoCampo = 'Grau de Relacionamento';
                    }
                    this.permitirAvancar = false;
                }

                if (!this.localPF.DocumentoRepresentante || this.localPF.DocumentoRepresentante == '') {
                    if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                        this.camposObrigatorios.erroDocumentoRepresentante = true;
                        nomeDoCampo = 'Documento do Representante';
                    }
                    this.permitirAvancar = false;
                }

                if (!this.localPF.EmailRepresentante || this.localPF.EmailRepresentante == '') {
                    if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                        this.camposObrigatorios.erroEmailRepresentante = true;
                        nomeDoCampo = 'E-mail do Representante';
                    }
                    this.permitirAvancar = false;
                }

                if (!this.localPF.CpfRepresentante || this.localPF.CpfRepresentante == '') {
                    if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                        this.camposObrigatorios.erroCpfRepresentante = true;
                        nomeDoCampo = 'CPF do Representante';
                    }
                    this.permitirAvancar = false;
                }

                // REPRESENTANTE ADICIONAL (todos obrigatórios se qualquer um estiver preenchido)
                const rep2AlgumPreenchido =
                    !!(this.localPF.NomeRepresentante2 || this.localPF.GrauRelacionamento2 ||
                    this.localPF.DocumentoRepresentante2 || this.localPF.EmailRepresentante2 ||
                    this.localPF.CpfRepresentante2);

                if (rep2AlgumPreenchido) {

                    if (!this.localPF.NomeRepresentante2 || this.localPF.NomeRepresentante2 == '') {
                        if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                            this.camposObrigatorios.erroNomeRepresentante2 = true;
                            nomeDoCampo = 'Nome do Representante (Adicional)';
                        }
                        this.permitirAvancar = false;
                    }

                    if (!this.localPF.GrauRelacionamento2 || this.localPF.GrauRelacionamento2 == '') {
                        if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                            this.camposObrigatorios.erroGrauRelacionamento2 = true;
                            nomeDoCampo = 'Grau de Relacionamento (Adicional)';
                        }
                        this.permitirAvancar = false;
                    }

                    if (!this.localPF.DocumentoRepresentante2 || this.localPF.DocumentoRepresentante2 == '') {
                        if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                            this.camposObrigatorios.erroDocumentoRepresentante2 = true;
                            nomeDoCampo = 'Documento do Representante (Adicional)';
                        }
                        this.permitirAvancar = false;
                    }

                    if (!this.localPF.EmailRepresentante2 || this.localPF.EmailRepresentante2 == '') {
                        if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                            this.camposObrigatorios.erroEmailRepresentante2 = true;
                            nomeDoCampo = 'E-mail do Representante (Adicional)';
                        }
                        this.permitirAvancar = false;
                    }

                    if (!this.localPF.CpfRepresentante2 || this.localPF.CpfRepresentante2 == '') {
                        if (submeter && nomeDoCampo === '' && this.permitirAvancar) {
                            this.camposObrigatorios.erroCpfRepresentante2 = true;
                            nomeDoCampo = 'CPF do Representante (Adicional)';
                        }
                        this.permitirAvancar = false;
                    }

                }
            }



            if (submeter && nomeDoCampo != '') {
                this.modalAlerta = {
                    mostrar: true,
                    tipo: 'warning',
                    titulo: 'Atenção: Campo obrigatório',
                    mensagem: `O campo ${nomeDoCampo} não foi informado, preencha a informação para avançar.`
                };
            }

            if (submeter && nomeDoCampoOpcionalInvalido != '' && nomeDoCampo == '') {
                this.modalAlerta = {
                    mostrar: true,
                    tipo: 'warning',
                    titulo: 'Atenção: Campo inválido',
                    mensagem: `O campo ${nomeDoCampoOpcionalInvalido} é opcional mas foi informado de forma inválida, preencha a informação para avançar.`
                };
            }

            return this.permitirAvancar;
            
        },
        ocupacaoProfissionalAlteracao() {
            this.localPF.OcupacaoOutro = '';
            this.salvarAlteracoesLocalmente();
        },
        salvarInformacoes() {
            this.$store.commit('SET_PF_SALVAR_INFO', true);
        },
        salvarAlteracoesLocalmente() {
            this.validarFormulario();
            this.$store.commit('SET_PF_SALVAR_INFO_BASICAS', this.localPF);
        },
        formatarDados(dados) {
            return {
                DataNascimento: this.converterData(dados.DataNascimento),
                Sexo: dados.Sexo || '',
                EstadoCivil: dados.EstadoCivil || '',
                Ocupacao: dados.Ocupacao || '',
                NumeroDocumento: dados.NumeroDocumento || '',
                TipoDocumento: dados.TipoDocumento || '',
                DataEmissao: this.converterData(dados.DataEmissao),
                OrgaoEmissao: dados.OrgaoEmissao || '',
                DocumentoUf: dados.DocumentoUf || '',
                Nacionalidade: dados.Nacionalidade || '',
                PaisNascimento: dados.PaisNascimento || '',
                Naturalidade: dados.Naturalidade || '',
                CidadeNascimento: dados.CidadeNascimento || '',
                Pais: dados.Pais || '',
                NomeMae: dados.NomeMae || '',
                NomePai: dados.NomePai || '',
                NomeConjugue: dados.NomeConjugue || '',
                CpfConjugue: dados.CpfConjugue || '',
                Logradouro: dados.Logradouro || '',
                LogradouroNumero: dados.LogradouroNumero || '',
                LogradouroComplemento: dados.LogradouroComplemento || '',
                Bairro: dados.Bairro || '',
                Cidade: dados.Cidade || '',
                Cep: dados.Cep || '',
                Uf: dados.Uf || '',
                LogradouroPais: dados.LogradouroPais || '',
                Telefone: dados.Telefone || '',
                Telefone2: dados.Telefone2 || '',
                Email: dados.Email || '',
                PoliticamenteExposta: dados.PoliticamenteExposta,
                PoliticamenteExpostaDescricao: dados.PoliticamenteExpostaDescricao || '',
                FormacaoProfissional: dados.FormacaoProfissional || '',
                Instituicao: dados.Instituicao || '',
                OcupacaoOutro: dados.OcupacaoOutro || '',
                CnpjTrabalha: dados.CnpjTrabalha || '',
                EnderecoComercial: dados.EnderecoComercial || '',
                EnderecoComercialNumero: dados.EnderecoComercialNumero || '',
                EnderecoComercialComplemento: dados.EnderecoComercialComplemento || '',
                EnderecoComercialBairro: dados.EnderecoComercialBairro || '',
                EnderecoComercialCep: dados.EnderecoComercialCep || '',
                EnderecoComercialCidade: dados.EnderecoComercialCidade || '',
                EnderecoComercialEstado: dados.EnderecoComercialEstado || '',
                EnderecoComercialPais: dados.EnderecoComercialPais || '',
                TelefoneComercial: dados.TelefoneComercial || '',
                EmailComercial: dados.EmailComercial || '',
                EnderecoCorrespondencia: dados.EnderecoCorrespondencia || '',
                LogradouroOutro: dados.LogradouroOutro || '',
                LogradouroNumeroOutro: dados.LogradouroNumeroOutro || '',
                LogradouroComplementoOutro: dados.LogradouroComplementoOutro || '',
                BairroOutro: dados.BairroOutro || '',
                CidadeOutro: dados.CidadeOutro || '',
                UfOutro: dados.UfOutro || '',
                CepOutro: dados.CepOutro || '',
                PaisOutro: dados.PaisOutro || '',
                ClienteIncapaz: dados.ClienteIncapaz,
                ClienteEmancipado: dados.ClienteEmancipado,
                NomeRepresentante: dados.NomeRepresentante || '',
                GrauRelacionamento: dados.GrauRelacionamento || '',
                EmissorOrdem: dados.EmissorOrdem,
                DocumentoRepresentante: dados.DocumentoRepresentante || '',
                EmailRepresentante: dados.EmailRepresentante || '',
                CpfRepresentante: dados.CpfRepresentante || '',
                PepRepresentante: dados.PepRepresentante,
                NomeRepresentante2: dados.NomeRepresentante2 || '',
                GrauRelacionamento2: dados.GrauRelacionamento2 || '',
                EmissorOrdem2: dados.EmissorOrdem2,
                DocumentoRepresentante2: dados.DocumentoRepresentante2 || '',
                EmailRepresentante2: dados.EmailRepresentante2 || '',
                CpfRepresentante2: dados.CpfRepresentante2 || '',
                PepRepresentante2: dados.PepRepresentante2,
                SituacaoLegal: dados.SituacaoLegal || 1
            };
        },
        converterData(dataString) {
            if (dataString && dataString !== '0001-01-01T00:00:00') {
                let data = new Date(dataString);
                let ano = data.getFullYear();
                let mes = (data.getMonth() + 1).toString().padStart(2, '0');
                let dia = data.getDate().toString().padStart(2, '0');
                return `${ano}-${mes}-${dia}`;
            } else {
                return null;
            }
        },
    },
    watch: {
        infoBasicas() {
            this.localPF = this.formatarDados(this.infoBasicas);
            this.localPF.Nome = this.infoBasicas.Nome;
            this.localPF.Cpf = this.infoBasicas.Cpf;
            this.validarFormulario();
            this.checkMenorIdade();
        },
        infoComplementoRepresentantes() {
            if (this.infoComplementoRepresentantes != null && this.infoComplementoRepresentantes.length > 0) {
                this.representantes = this.infoComplementoRepresentantes;
            }
        },
        'localPF.Naturalidade'() {
            if(this.localPF.Naturalidade){
                 this.$store.dispatch('FETCH_CONSULTA_CIDADES', this.localPF.Naturalidade);
            }
        },
        'localPF.Nacionalidade'() {
            if(this.localPF.Nacionalidade != 1){
                this.localPF.Naturalidade = null;
            }else{
                this.localPF.PaisNascimento = null;
            }
        },
        
    }
}

</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600&display=swap');

.formulario {
    width: 100%;
}

.agrupamentoFormulario {
    width: 100%;
    display: inline-flex;
    margin-top: 10px;
}

.categoriaAgrupamentoFormulario {
    width: 10%;
    margin-right: 15px;

    h5 {
        font-family: 'Inter', sans-serif;
    }
}

.label__field {
    padding-right: 30px;
}

.camposAgrupamentoFormulario {
    width: 90%;

    .row {
        width: 100%;
        display: inline-flex;
        gap: 8px;
        margin-bottom: 10px;
    }

    .accept {
        display: inline-flex;

        &:checked {
            +label {
                &:before {
                    background: white;
                    border: 1px solid black;
                    transition: background 0.3s;
                }
            }

            +label {
                &::after {
                    opacity: 1;
                    transition: all;
                    background: transparent;
                }
            }
        }
    }

    .radio {
        display: flex;
        align-items: center;
        margin-right: 25px;

        @media (max-width: 768px) {
            margin-right: 0;
            margin-bottom: 20px;
        }

        .field__radio {
            width: 20px;
            height: 20px;
        }

        .label__radio {
            margin-left: 5px;
            margin-right: 40px;
            margin-top: 5px;
        }
    }

    select {
        width: 105% !important;
    }

    label {
        font-family: 'Inter', sans-serif;
        font-weight: 500;
        font-size: 14px;
        line-height: 20px;
        color: #344054;
        display: block;
        margin-bottom: 8px;
    }
}

.title {

    border-bottom: 1px solid #EAECF0;

    h3 {
        margin-top: 50px;
        color: #101828;
        font-weight: 500;
        font-family: 'Inter', sans-serif;
    }

    h5 {
        margin-top: 5px;
        margin-block-start: 0;
        color: #667085;
        font-weight: 400;
        font-family: 'Inter', sans-serif;
    }
}
</style>